import { React } from 'react'
import { Typography, Layout } from 'antd';

const { Content } = Layout;
const { Title } = Typography;
const titleStyle = {
    textAlign: 'center',
    color: 'red',
};

const contentStyle = {
    textAlign: 'center',
    backgroundColor: '#ffffff',
    textAlign: 'Justify'
};
const contentList = {
    color: 'inherit',
    textDecoration: 'none'
}; 
function Contacto() {
    return (
        <Content style={contentStyle}>
            <Title level={2} style={titleStyle} >Contacto</Title>
              <Title level={5} style={{ textAlign: 'center'}}>
                <ol style={{ listStyleType: 'none'}}>
                  <li><a href='tel:3332084420' style={contentList}>Tel: 3332084420</a></li>
                  <li><a href='https://api.whatsapp.com/send/?phone=3316026164&text=%C2%A1Necesito+ayuda+con+mi+pago%21&type=phone_number&app_absent=0' style={contentList}>Whatsap Apymsa: 3316026164</a></li>
                  <li><a href='https://api.whatsapp.com/send/?phone=3316025603&text=%C2%A1Necesito+ayuda+con+mi+pago%21&type=phone_number&app_absent=0' style={contentList}>Whatsap Autex: 3316025603</a></li>
                  <li><a href='mailto:contacto@apymsa.com.mx' style={contentList}>Correo: contacto@apymsa.com.mx</a></li>
                </ol>
              </Title>
        </Content>
    )
}

export default Contacto;